import { Select, SelectProps } from '@mantine/core';

import { useGetZipsQuery } from '@api/locations.api';

export default function ZipSelector(props: { city: string } & SelectProps) {
  const { data = [], isLoading } = useGetZipsQuery(props.city, {
    skip: props.disabled,
  });

  return (
    <Select
      label="CAP"
      placeholder="Seleziona CAP"
      data={Array.from(
        new Map(
          data
            .toSorted((a, b) => (a.cap > b.cap ? 1 : -1))
            .map((zip) => [zip.cap, zip]),
        ).values(),
      ).map((zip) => ({
        value: zip.cap,
        label: zip.cap,
      }))}
      searchable
      {...props}
      disabled={isLoading || props.disabled}
    />
  );
}
